import React from 'react';
import { IFormData } from '../interface';

export function setFormUser(
  event: React.FormEvent<HTMLInputElement>,
  form: IFormData,
  setForm: React.Dispatch<React.SetStateAction<IFormData>>
) {
  event.preventDefault();
  setForm({ ...form, email: event.currentTarget.value });
}

export function setFormPassword(
  event: React.FormEvent<HTMLInputElement>,
  form: IFormData,
  setForm: React.Dispatch<React.SetStateAction<IFormData>>
) {
  event.preventDefault();
  const { value } = event.currentTarget;
  setForm({ ...form, password: value });
}
